import FormBuilder from '@/components/admin/FormBuilder'

const AdminFormBuilder = () => {
  return <FormBuilder />
}

export default AdminFormBuilder